import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import langMsg from '@blade/common/pages/result-details/lang/indexTask';
import { fromPage } from '@blade/common/interfaces/result-details';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
// import colors from '@/styles/color.scss';
import DrawWithImg from '@blade/common/components/paint/draw-with-img.vue';
import { getRoiData, changeIndex, getTaskTargetStr, getLocalHeadPoint } from '@blade/common/pages/result-details/common/util';
import lodash from 'lodash';
import { setCustomOptions } from '@blade/common/components/paint/src/drawer-options';
import headFrame from '@blade/common/pages/alarm-center-dialog/components/head-frame.vue';
import libraryList from '@blade/common/pages/alarm-center-dialog/components/library-list.vue';
import ImageUtil from '@blade/common/utils/screenShot';
let DetailsLeftPicture = class DetailsLeftPicture extends Vue {
    layerVal;
    filterImgLv;
    srcList;
    indexImgProp;
    detailsData;
    detailsType;
    detailsRoute;
    offset;
    imageDetect;
    isChartType;
    pictureRef;
    myCanvasRef;
    cardShowRef;
    drawImgRef;
    onUpdateObject() {
        this.headFrameShow = false;
        this.libraryListShow = false;
        this.polygonData = [];
        this.details = this.detailsData;
        this.getSpecifiedStyle();
        this.$nextTick(() => {
            this.dragHandle();
        });
    }
    indexImg = 0;
    multiples = 1;
    routePage = fromPage.FEATURES_PAGE;
    details = {};
    headPoint = [];
    headPointStatus = true;
    graph = {};
    headFrameShow = false;
    libraryListShow = false;
    headStyle = {
        top: 0,
        left: 0,
    };
    featureType = ''; // hover类型
    specifiedStyle = {
        width: 0,
        height: 0,
    };
    polygonData = [];
    isFirstLoad = true;
    type = '';
    moveIndex = 0;
    srcShowList = [];
    src = '';
    height = 450;
    width = 800;
    imgUrl = '';
    chartType = '';
    onIndexImg() {
        this.indexImg = this.indexImgProp;
        this.srcShowList.splice(this.indexImgProp, 1, this.srcList[this.indexImgProp]);
        this.headFrameShow = false;
        this.libraryListShow = false;
        this.zoomReset();
        this.$nextTick(() => {
            this.cardShowRef.setActiveItem(this.indexImg);
            this.dragHandle();
        });
    }
    onUpdateImageDetect(val) {
        this.polygonData = [];
        this.headPoint = [];
        if (this.headPointStatus) {
            this.drawRoi();
        }
    }
    onLayerValChange(newVal) {
        this.polygonData = [];
        this.headPointStatus = false;
        this.isFirstLoad = false;
        if (newVal) {
            this.headPointStatus = true;
            this.drawRoi();
        }
    }
    onSrcList(newVal) {
        this.srcShowList = [];
        this.srcShowList = newVal.filter((item, index) => {
            return index < 1;
        });
        this.src = this.srcShowList[0];
    }
    mounted() {
        this.$nextTick(() => {
            this.dragHandle();
        });
    }
    // 添加脑图子节点
    addChart() {
        this.$emit('addChart');
    }
    initData() {
        // 加载-智能提取框
        this.imageDetect?.forEach((item) => {
            if (item?.featureList && item?.featureList.length > 0) {
                item?.featureList.forEach((ele) => {
                    let rectObj = {
                        status: 'end',
                        type: 'rect',
                        featureType: ele?.featureType,
                        options: setCustomOptions('rectai'),
                        name: '',
                        vertices: ele?.boundingPoly?.vertices,
                        verticesData: ele?.imageBoundingPoly?.vertices,
                        version: ele?.version,
                        featureValue: ele?.featureValue,
                        idempotentId: ele?.idempotentId,
                    };
                    this.polygonData.push({ ...rectObj });
                });
            }
        });
    }
    get frameType() {
        let frameTypeVal = '';
        if (this.detailsRoute === fromPage.TASK_PAGE) {
            if (this.details?.isDetailsType) {
                if (this.indexImg > 0) {
                    frameTypeVal = 'rearCapture'; // 时空 同行人 图搜
                }
                else {
                    frameTypeVal = 'alarm'; // 任务-告警结果
                }
            }
            else {
                // 解析结果
                frameTypeVal = 'rearCapture';
            }
        }
        if (this.detailsRoute === fromPage.EVENT_PAGE) {
            if (this.indexImg > 0) {
                frameTypeVal = 'rearCapture';
            }
            else {
                frameTypeVal = 'searchEvent'; // 搜索中心-事件
            }
        }
        if (this.detailsRoute === fromPage.FEATURES_PAGE || this.detailsRoute === fromPage.TIME_PAGE) {
            frameTypeVal = 'rearCapture';
        }
        if (this.detailsRoute === fromPage.FILECLUSTER_PAGE || this.detailsRoute === fromPage.BIGDATA_PAGE) {
            frameTypeVal = 'fileCluster';
        }
        return frameTypeVal;
    }
    showIsLibrary(val) {
        if (val) {
            this.headFrameShow = false;
        }
        this.libraryListShow = val;
        this.type = this.featureType;
    }
    async hover(e1) {
        this.imgUrl = await ImageUtil.screenShot(e1.graph?.verticesData, this.srcList[this.indexImgProp], {
            width: 800,
            height: 450,
        });
        // this.imgUrl = await ImageUtil.screenShot(e1.graph?.vertices, this.srcList[this.indexImgProp], { width: 800, height: 450 });
        const addChart = {
            ...e1.graph,
            extractBase64Image: this.imgUrl,
        };
        // 详情红框是否需要展示添加子节点
        this.chartType = addChart?.idempotentId ? this.isChartType : '';
        this.$emit('addChartDetect', addChart);
        this.featureType = e1?.graph?.featureType;
        this.graph = e1?.graph;
        console.log('this.graph  e1', e1);
        if ((this.detailsType === 'FACE_MATCH' ||
            this.detailsType === 'INCIDENT_FACE_UNMATCHED' ||
            this.detailsType === 'OBJECT_AUTOMOBILE' ||
            this.detailsType === 'OBJECT_PEDESTRIAN' ||
            this.detailsType === 'OBJECT_HUMAN_POWERED_VEHICLE' ||
            this.detailsType === 'OBJECT_FACE') &&
            !e1?.graph?.featureType) {
            this.featureType = this.detailsType;
        }
        // if (this.detailsRoute === fromPage.BIGDATA_PAGE) {
        //   return;
        // }
        // 判断是否一键搜索 FACE_MATCH - 人脸比中 INCIDENT_FACE_UNMATCHED- 人脸未必中 OBJECT_FACE - 时空/图搜人脸 FACE_PEDESTRIAN-人脸人体联合
        if (this.detailsType === 'FACE_MATCH' ||
            this.detailsType === 'INCIDENT_FACE_UNMATCHED' ||
            this.detailsType === 'OBJECT_FACE' ||
            this.detailsType === 'FACE_PEDESTRIAN' ||
            this.detailsType === 'OBJECT_PEDESTRIAN' ||
            this.detailsType === 'OBJECT_AUTOMOBILE' ||
            this.featureType) {
            if (e1.graph.type === 'rect') {
                // this.headFrameShow = true;
                this.showPosition(e1);
            }
        }
    }
    onMoveOut() {
        this.headFrameShow = false;
        // this.libraryListShow = false;
        document.onmousemove = null;
        this.moveIndex = 0;
    }
    showPosition(e1) {
        const drawImgRef = this.pictureRef[this.indexImg];
        this.headStyle.left = e1.vertex.x + drawImgRef.offsetLeft;
        this.headStyle.top = e1.vertex.y + drawImgRef.offsetTop;
        this.headFrameShow = true;
    }
    dragHandle() {
        const moveElement = this.pictureRef[this.indexImg];
        // 外框的高度
        const outerHeight = this.cardShowRef.$el.offsetHeight;
        // 外框的宽度
        const outerWidth = this.cardShowRef.$el.offsetWidth;
        let minTop = 0;
        let maxTop = 0;
        let minLeft = 0;
        let maxLeft = 0;
        if (!moveElement)
            return;
        moveElement.onmousedown = (e) => {
            // 算出鼠标相对元素的位置
            let disX = e.clientX - moveElement.offsetLeft;
            let disY = e.clientY - moveElement.offsetTop;
            document.onselectstart = function () {
                return false;
            };
            // y坐标点偏移量--因为使用transform放大缩小，会影响0,0坐标值的位置
            let offsetTop = Math.abs(moveElement.offsetHeight - moveElement.offsetHeight * this.multiples) / 2;
            // y坐标点偏移量
            let offsetLeft = Math.abs(moveElement.offsetWidth - moveElement.offsetWidth * this.multiples) / 2;
            // 保留图片的90%不被拖出
            const noDragHeight = moveElement.offsetHeight * this.multiples * 0.9;
            const noDragWith = moveElement.offsetWidth * this.multiples * 0.9;
            if (this.multiples <= 1) {
                minTop = -(noDragHeight + offsetTop);
                maxTop = noDragHeight + (outerHeight - moveElement.offsetHeight) + offsetTop;
                minLeft = -(noDragWith + offsetLeft);
                maxLeft = noDragWith + (outerWidth - moveElement.offsetWidth) + offsetLeft;
            }
            else {
                minTop = -(noDragHeight - offsetTop);
                maxTop = outerHeight * 0.9 + offsetTop;
                minLeft = -(noDragWith - offsetLeft);
                maxLeft = outerWidth * 0.9 + offsetLeft;
            }
            document.onmousemove = (e) => {
                // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX;
                let top = e.clientY - disY;
                if (left < minLeft) {
                    left = minLeft;
                }
                if (left > maxLeft) {
                    left = maxLeft;
                }
                if (top < minTop) {
                    top = minTop;
                }
                if (top > maxTop) {
                    top = maxTop;
                }
                moveElement.style.left = left + 'px';
                moveElement.style.top = top + 'px';
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                document.onselectstart = function () {
                    return true;
                };
            };
        };
    }
    getSpecifiedStyle() {
        this.$nextTick(() => {
            const width = this.pictureRef[this.indexImg].offsetWidth;
            const height = this.pictureRef[this.indexImg].offsetHeight;
            this.specifiedStyle = {
                width: width,
                height: height,
            };
            this.drawRoi();
        });
    }
    drawRoi() {
        console.log('this.details', this.details);
        console.log(333333, this.detailsType);
        const type = getTaskTargetStr('incidentType', 'type', this.detailsType);
        this.polygonData = [];
        const name = this.getName(this.detailsType);
        if (type === 'Face') {
            // 搜索中心--事件搜索
            if (this.detailsRoute === fromPage.EVENT_PAGE) {
                if (this.details.incidentRecordVO) {
                    this.polygonData = changeIndex(this.details.incidentRecordVO, type, this.detailsType, this.headPointStatus, name);
                }
                else {
                    // 同行人员数据
                    this.polygonData = changeIndex(this.details, type, 'EVENT_FACE', this.headPointStatus, name);
                }
            }
            // 数据挖掘、人像聚档
            if (this.detailsRoute === fromPage.FILECLUSTER_PAGE || this.detailsRoute === fromPage.BIGDATA_PAGE) {
                if (this.details.portraitImageInPanoramics) {
                    // 同行人员数据
                    this.polygonData = changeIndex(this.details, type, 'EVENT_FACE', this.headPointStatus);
                }
                else {
                    const data = changeIndex(this.details, type, 'FILECLUSTER_FACE', this.headPointStatus);
                    this.getCoordinatePoints(lodash.cloneDeep(data));
                }
            }
            // 任务管理
            if (this.detailsRoute === fromPage.TASK_PAGE) {
                if (this.details.portraitImageInPanoramics) {
                    this.polygonData = changeIndex(this.details, type, 'EVENT_FACE', this.headPointStatus, name);
                }
                else {
                    // 同行人员数据
                    this.polygonData = changeIndex(this.details, type, this.detailsType, this.headPointStatus, name);
                }
            }
            // 时空检索、以图搜图
            if (this.detailsRoute === fromPage.TIME_PAGE || this.detailsRoute === fromPage.FEATURES_PAGE) {
                this.polygonData = changeIndex(this.details, type, this.detailsType, this.headPointStatus, name);
            }
        }
        else if (type === 'Automobile') {
            this.polygonData = changeIndex(this.details, type, 'EVENT_FACE', this.headPointStatus, name);
        }
        else if (type === 'MotorBike') {
            this.polygonData = changeIndex(this.details, type, 'EVENT_FACE', this.headPointStatus, name);
        }
        else if (type === 'Object') {
            this.polygonData = getRoiData(this.details?.incidentRecordVO, type, this.detailsType, name);
        }
        else if (type === 'Everything') {
            this.polygonData = changeIndex(this.details, type, 'EVENT_FACE', this.headPointStatus, name);
        }
        else {
            if (this.details.crowdAnnotation) {
                this.headPoint = getLocalHeadPoint(this.details.crowdAnnotation, type, this.detailsType);
                this.polygonData = getRoiData(this.details, type, this.detailsType, name);
                this.headPoint.map((item) => {
                    let itemObj = {
                        status: 'end',
                        type: 'circle',
                        options: setCustomOptions('circle'),
                        vertices: [item],
                    };
                    this.polygonData.push(JSON.parse(JSON.stringify(itemObj)));
                });
            }
            else {
                const modelType = this.details?.incidentRecordVO?.taskConsist?.modelType || '';
                this.headPoint = getLocalHeadPoint(this.details?.incidentRecordVO?.crowdAnnotation, type, this.detailsType, modelType);
                this.polygonData = getRoiData(this.details.incidentRecordVO, type, this.detailsType, name, modelType);
                this.headPoint.map((item) => {
                    let itemObj = {
                        status: 'end',
                        type: 'circle',
                        options: setCustomOptions('circle'),
                        vertices: [item],
                    };
                    this.polygonData.push(JSON.parse(JSON.stringify(itemObj)));
                });
            }
        }
        this.initData();
    }
    // 处理坐标点
    getCoordinatePoints(data) {
        const img = new Image();
        img.src = this.srcList[this.indexImgProp];
        img.onload = () => {
            if (img.complete) {
                const processedData = [];
                const { width, height } = img;
                data.forEach((d) => {
                    d.vertices.forEach((point) => {
                        point.x = Number((point.x / width).toFixed(6));
                        point.y = Number((point.y / height).toFixed(6));
                    });
                    processedData.push(d);
                });
                this.polygonData.push(...processedData);
            }
        };
    }
    getName(val) {
        const i18n = getTaskTargetStr('incidentType', 'alertDetailI18n', val);
        return this.$t(i18n).toString();
    }
    zoomIn() {
        this.multiples += 0.25;
    }
    zoomOut() {
        if (this.multiples <= 0.3) {
            return;
        }
        this.multiples -= 0.25;
    }
    zoomReset() {
        this.multiples = 1;
        if (!this.pictureRef[this.indexImg])
            return;
        this.pictureRef[this.indexImg].style.top = 'auto';
        this.pictureRef[this.indexImg].style.left = 'auto';
    }
    handleLeft() {
        this.cardShowRef.setActiveItem(this.indexImg - 1);
        this.zoomReset();
        this.$emit('change');
    }
    handleRight() {
        this.cardShowRef.setActiveItem(this.indexImg + 1);
        this.zoomReset();
        this.$emit('change');
    }
    changeClick(e) {
        this.$emit('changeImgIndex', e);
    }
};
__decorate([
    Prop()
], DetailsLeftPicture.prototype, "layerVal", void 0);
__decorate([
    Prop()
], DetailsLeftPicture.prototype, "filterImgLv", void 0);
__decorate([
    Prop()
], DetailsLeftPicture.prototype, "srcList", void 0);
__decorate([
    Prop()
], DetailsLeftPicture.prototype, "indexImgProp", void 0);
__decorate([
    Prop()
], DetailsLeftPicture.prototype, "detailsData", void 0);
__decorate([
    Prop()
], DetailsLeftPicture.prototype, "detailsType", void 0);
__decorate([
    Prop()
], DetailsLeftPicture.prototype, "detailsRoute", void 0);
__decorate([
    Prop()
], DetailsLeftPicture.prototype, "offset", void 0);
__decorate([
    Prop()
], DetailsLeftPicture.prototype, "imageDetect", void 0);
__decorate([
    Prop()
], DetailsLeftPicture.prototype, "isChartType", void 0);
__decorate([
    Ref()
], DetailsLeftPicture.prototype, "pictureRef", void 0);
__decorate([
    Ref()
], DetailsLeftPicture.prototype, "myCanvasRef", void 0);
__decorate([
    Ref()
], DetailsLeftPicture.prototype, "cardShowRef", void 0);
__decorate([
    Ref()
], DetailsLeftPicture.prototype, "drawImgRef", void 0);
__decorate([
    Watch('detailsData', { deep: true })
], DetailsLeftPicture.prototype, "onUpdateObject", null);
__decorate([
    Watch('indexImgProp')
], DetailsLeftPicture.prototype, "onIndexImg", null);
__decorate([
    Watch('imageDetect')
], DetailsLeftPicture.prototype, "onUpdateImageDetect", null);
__decorate([
    Watch('layerVal')
], DetailsLeftPicture.prototype, "onLayerValChange", null);
__decorate([
    Watch('srcList', { immediate: true })
], DetailsLeftPicture.prototype, "onSrcList", null);
DetailsLeftPicture = __decorate([
    Component({
        name: 'DetailsLeftPicture',
        components: { BlurPicture, DrawWithImg, headFrame, libraryList },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], DetailsLeftPicture);
export default DetailsLeftPicture;
